import { Bubble } from './bubble';
import '../studyCreationGuide.scss';

interface StepHeaderProps {
  stepNumber: number;
  title: string;
}

export const StepHeader: React.FC<StepHeaderProps> = ({
  stepNumber,
  title,
}) => {
  return (
    <div className="section-title">
      <Bubble type="active">{stepNumber}</Bubble>
      <span>{title}</span>
    </div>
  );
};
